<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.complementaryExams', 1) }} to {{ $tc('message.prenatalConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                            id="prenatalConsultationInformation-group"
                            :label="$tc('message.prenatalConsultations', 1)"
                            label-for="prenatalConsultationInformation"
                    >
                        <b-form-input
                                id="prenatalConsultationInformation"
                                v-model="prenatalConsultationInformation"
                                type="text"
                                disabled
                                placeholder=""
                        ></b-form-input>

                        <b-form-invalid-feedback>
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                        <span v-if="errorshasField('consultation')" style="color:red">
                                    {{getErrorsField('consultation')}}
                                    </span>
                    </b-form-group>
                    <b-form-group
                            id="complementaryExaminations-group"
                            :label="$t('message.select')+' '+$tc('message.complementaryExams', 2)"
                            label-for="complementaryExamination-0">
                        <!-- Options -->
                        <select id="multiple" multiple v-model="form.examensComplementaire">
                            <option v-for="item in mComplementaries" :value="item.id">
                                {{ item.reference }}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group
                            id="complementaryExaminations-group"
                            :label="$tc('message.complementaryExams', 1)"
                            label-for="complementaryExamination-0">
                        <b-input-group
                                v-for="(complementaryExamination, index) in complementaryExaminations"
                                :key="index"
                                :class="{ 'mt-3': index }"
                        >
                            <b-form-input
                                    :id="`complementaryExamination-${ index }`"
                                    :value="complementaryExamination"
                                    v-model="complementaryExaminations[index]"
                            ></b-form-input>

                            <b-input-group-append>
                                <b-button
                                        v-if="!complementaryExaminations[index] || complementaryExaminations[index].length < 2"
                                        disabled
                                        variant="primary">
                                    {{ $t('message.add') }}
                                </b-button>

                                <b-button
                                        v-else
                                        @click="addComplementaryExaminationField(index)"
                                        variant="primary">
                                    {{ $t('message.add') }}
                                </b-button>

                                <b-button
                                        @click="removeComplementaryExaminationField(index)"
                                        variant="danger"
                                        v-if="index">
                                    {{ $t('message.remove') }}
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>


                    <b-button type="submit" variant="primary">
                        {{ $t('message.add') }}
                    </b-button>

<!--                    <b-button type="reset" variant="danger">-->
<!--                        {{ $t('message.reset') }}-->
<!--                    </b-button>-->
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import SlimSelect from 'slim-select';
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    export default {
        name: "AddComplementaryExamToPrenatalConsultation",
        computed: {
            ...mapGetters(["prenatalConsultation","complementaryExams"]),
            prenatalConsultationInformation :function(){
                return this.prenatalConsultation.type_de_consultation;
            },
            mComplementaries: function() {
                let eArray = [];

                _.forEach(this.complementaryExams, function(exam) {
                    let e = {};

                    e.reference = exam.reference;
                    if(exam.description){
                        e.description = exam.description.length > 20 ? exam.description.substr(0, 20) + '...' : exam.description;
                    }else{
                        e.description = ''
                    }
                    e.id = exam.id;

                    eArray.push(e);
                });

                return eArray;
            },
        },
        data() {
            return {
                consultation_id: this.$route.params.consultation,
                form: {
                    examensComplementaire: [],
                },
                show: true,
                complementaryExaminations: ['']
            }
        },
        methods: {
            addComplementaryExaminationField: function(index) {
                if (this.complementaryExaminations[index] && this.complementaryExaminations[index].length >= 2) {
                    this.complementaryExaminations.push('');
                }
            },
            removeComplementaryExaminationField: function(index) {
                this.complementaryExaminations.splice(index, 1);
            },
            getComplementaryExams() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getComplementaryExams', { args : args });
            },

            getConsultation() {
                let args = {
                    consultation: this.consultation_id
                };

                this.$store.dispatch("getPrenatalConsultation", { args });
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                if (this.form.examensComplementaire.length >0 || this.complementaryExaminations.length >0){
                    if(this.complementaryExaminations.length >0){
                        let longueur = this.complementaryExaminations.length -1;
                        if((this.complementaryExaminations[longueur]).length ==0){
                            this.complementaryExaminations.splice(longueur, 1);
                        }
                    }
                    // if(!this.$v.$invalid) {
                    let args = {
                        consultation: this.prenatalConsultation.id,
                        examensComplementaire: this.form.examensComplementaire.length >0 ? this.form.examensComplementaire : null,
                        examensComplementaireACreer:this.complementaryExaminations.length >0 ?this.complementaryExaminations : null
                    };

                    let successMessage = this.$i18n.t('message.physicalExamAdded');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('addPrenatalConsultationComplementarieExam', { args, errorMessages, successMessage });
                    // }
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                // this.form.reference = '';
                // this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            }
        },
        mounted() {
            this.getConsultation();
            this.getComplementaryExams();
            new SlimSelect({
                select: '#multiple',
                placeholder: 'Select Complementary examination'
            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>